module.exports = "<p>\r\n  lift-user works!\r\n</p>\r\n"